var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{attrs:{"content":_vm.value,"placement":"top"}},[_c('el-switch',{attrs:{"active-color":"#13ce66","inactive-color":"#ff4949","active-value":_vm.enable,"inactive-value":_vm.disabled},on:{"change":(event) =>
          _vm.changeStatus(
            _vm.$attrs.row ?? this.row,
            _vm.$attrs.column ?? this.col,
            event
          )},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }